"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var table_1 = __importDefault(require("relements/build/esm/ui/table"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var BinIcon_1 = __importDefault(require("relements/build/esm/ui/icons/BinIcon"));
var JourneyIcon_1 = __importDefault(require("relements/build/esm/ui/icons/JourneyIcon"));
require("./MetaAlgoliaMapping.scss");
var SplitModal_1 = __importDefault(require("./SplitModal"));
var MergeModal_1 = __importDefault(require("./MergeModal"));
var ACTION_DETAILS_KEY = 'action_details';
var META_COLUMNS_KEY = 'meta_columns';
var ALGOLIA_MAPPING_KEY = 'algolia_mapping_json';
var ThemedDropButton = styled_components_1["default"](button_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  cursor: pointer;\n  height: 32px;\n"], ["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  cursor: pointer;\n  height: 32px;\n"])), function (props) { return props.theme.colors.red.pastel; }, function (props) { return props.theme.colors.red.haptik; }, function (props) { return props.theme.colors.red.haptik; });
var ThemedSplitButton = styled_components_1["default"](button_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  cursor: pointer;\n  height: 32px;\n"], ["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  cursor: pointer;\n  height: 32px;\n"])), function (props) { return props.theme.colors.blue.pastel; }, function (props) { return props.theme.colors.blue.haptik; }, function (props) { return props.theme.colors.blue.haptik; });
var ThemedBinIcon = styled_components_1["default"](BinIcon_1["default"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n"], ["\n  width: 16px;\n  height: 16px;\n"])));
var ThemedJourneyIcon = styled_components_1["default"](JourneyIcon_1["default"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n"], ["\n  width: 16px;\n  height: 16px;\n"])));
// columns for table component
var columns = [
    {
        title: 'Active',
        sortKey: 'active',
        width: '3%',
    },
    {
        title: 'Meta Column',
        sortKey: 'metaColumn',
        width: '32%',
    },
    {
        title: 'Algolia Field',
        sortKey: 'algoliaField',
        width: '25%',
    },
    {
        title: 'Data Type',
        sortKey: 'dataType',
        width: '18%',
    },
    {
        title: 'Actions',
        sortKey: 'actions',
        width: '22%',
    },
];
var FIELD_TYPE_OPTIONS = [
    {
        id: '0',
        name: 'no type',
    },
    {
        id: '1',
        name: 'string',
    },
    {
        id: '2',
        name: 'number',
    },
    {
        id: '3',
        name: 'boolean',
    },
    {
        id: '4',
        name: 'array',
    },
];
var MetaAlgoliaMapping = function (_a) {
    var _b, _c, _d;
    var _e = _a.active, active = _e === void 0 ? false : _e, closeModal = _a.closeModal, actionData = _a.actionData, onAdvancedSettingsChange = _a.onAdvancedSettingsChange;
    var _f = react_1.useState(false), splitModalActive = _f[0], setSplitModalActive = _f[1];
    var _g = react_1.useState(null), splitModalData = _g[0], setSplitModalData = _g[1];
    var _h = react_1.useState(false), mergeModalActive = _h[0], setMergeModalActive = _h[1];
    var _j = react_1.useState(null), mergeModalData = _j[0], setMergeModalData = _j[1];
    var actionDetails = (_b = actionData[ACTION_DETAILS_KEY]) !== null && _b !== void 0 ? _b : {};
    var currentDetail = (_c = actionDetails === null || actionDetails === void 0 ? void 0 : actionDetails[4]) !== null && _c !== void 0 ? _c : {};
    var _k = currentDetail, _l = META_COLUMNS_KEY, _m = _k[_l], rawMetaColumns = _m === void 0 ? [] : _m, _o = ALGOLIA_MAPPING_KEY, rawAlgoliaMapping = _k[_o];
    var metaColumns = rawMetaColumns;
    var config = (_d = rawAlgoliaMapping === null || rawAlgoliaMapping === void 0 ? void 0 : rawAlgoliaMapping.mappings) !== null && _d !== void 0 ? _d : {};
    var generateColumn = function (content) { return ({
        content: content,
    }); };
    // Build canonical row map from metaColumns
    var rowMap = metaColumns.reduce(function (acc, column) {
        acc[column] = {
            id: column,
            active: true,
            metaName: column,
            algoliaName: column,
            dataType: 'no type',
            actions: ['Split', 'Drop'],
        };
        return acc;
    }, {});
    // Apply transformations
    Object.entries(config || {}).forEach(function (_a) {
        var column = _a[0], actions = _a[1];
        // Track the current field name as it gets renamed
        var currentFieldName = column;
        var currentRow = rowMap[column];
        if (!currentRow)
            return;
        actions.forEach(function (actionConfig) {
            var _a, _b;
            // Get the current row (it might have been moved due to rename)
            var baseRow = rowMap[currentFieldName] || currentRow;
            if (!baseRow)
                return;
            switch (actionConfig.action) {
                case 'rename': {
                    var nextAlgoliaName = (_a = actionConfig.final_name) !== null && _a !== void 0 ? _a : baseRow.algoliaName;
                    // Update in place to preserve order
                    baseRow.algoliaName = nextAlgoliaName;
                    baseRow.id = nextAlgoliaName;
                    // Update current field name and row reference for subsequent actions
                    // We'll move the entry to the new key at the end to preserve order
                    if (nextAlgoliaName !== currentFieldName) {
                        // Create entry with new key, but keep old entry for now
                        rowMap[nextAlgoliaName] = baseRow;
                        currentFieldName = nextAlgoliaName;
                    }
                    currentRow = baseRow;
                    if (actionConfig.final_type) {
                        currentRow.dataType = actionConfig.final_type;
                    }
                    break;
                }
                case 'type_cast': {
                    // Use currentRow which tracks the renamed field
                    if (currentRow) {
                        currentRow.dataType = actionConfig.final_type;
                    }
                    else if (baseRow) {
                        baseRow.dataType = actionConfig.final_type;
                    }
                    break;
                }
                case 'drop': {
                    baseRow.active = false;
                    break;
                }
                case 'merge': {
                    var metaName_1 = column;
                    actionConfig.merge_with.forEach(function (mergeColumn) {
                        metaName_1 = metaName_1 + " + " + mergeColumn;
                    });
                    // Clone merge action to allow downstream updates without mutating config
                    var mergeActionClone = __assign(__assign({}, actionConfig), { merge_with: __spreadArrays((actionConfig.merge_with || [])) });
                    var mergedRow = __assign(__assign({}, baseRow), { id: actionConfig.final_name, metaName: metaName_1, algoliaName: actionConfig.final_name, dataType: (_b = actionConfig.final_type) !== null && _b !== void 0 ? _b : baseRow.dataType, mergedFrom: __spreadArrays([column], (actionConfig.merge_with || [])), originalMergeAction: mergeActionClone });
                    rowMap[mergedRow.id] = mergedRow;
                    // Remove original merged source fields from rowMap so they don't appear in table
                    if ('mergedFrom' in mergedRow) {
                        mergedRow.mergedFrom.forEach(function (source) {
                            delete rowMap[source];
                        });
                    }
                    break;
                }
                case 'split': {
                    if (actionConfig.final_names && actionConfig.final_names.length > 0) {
                        var sourceSnapshot_1 = __assign({}, baseRow);
                        // Clone to allow downstream updates (rename/type) without mutating config
                        var splitActionClone_1 = __assign(__assign({}, actionConfig), { final_names: __spreadArrays(actionConfig.final_names), final_types: __assign({}, (actionConfig.final_types || {})) });
                        splitActionClone_1.final_names.forEach(function (name, index) {
                            var _a, _b;
                            rowMap[name] = __assign(__assign({}, sourceSnapshot_1), { id: name, metaName: column + "_" + (index + 1), algoliaName: name, dataType: (_b = (_a = splitActionClone_1.final_types) === null || _a === void 0 ? void 0 : _a[name]) !== null && _b !== void 0 ? _b : sourceSnapshot_1.dataType, splitFrom: column, originalSplitAction: splitActionClone_1 });
                        });
                    }
                    delete rowMap[column];
                    break;
                }
                default:
                    break;
            }
        });
    });
    // Rebuild rowMap in correct order: regular columns first, then split/merged at the end
    // Create ordered array of rows, then rebuild rowMap using current id as key
    var regularRows = [];
    var splitAndMergedRows = [];
    var processedIds = new Set();
    // Helper to find current name after renames
    var getCurrentName = function (originalName) {
        var actions = config[originalName] || [];
        var renameAction = actions.find(function (a) { return a.action === 'rename'; });
        return (renameAction === null || renameAction === void 0 ? void 0 : renameAction.final_name) || originalName;
    };
    // Helper to find row by id (handles both old and new keys)
    var findRowById = function (id) {
        return rowMap[id] || Object.values(rowMap).find(function (r) { return r.id === id; });
    };
    // First pass: collect regular columns in metaColumns order
    metaColumns.forEach(function (column) {
        var columnActions = config[column] || [];
        var splitAction = columnActions.find(function (a) { return a.action === 'split'; });
        var mergeAction = columnActions.find(function (a) { return a.action === 'merge'; });
        // Skip split and merged columns in first pass
        if (!splitAction && !mergeAction) {
            // Regular column (might have been renamed)
            var currentName = getCurrentName(column);
            var row = findRowById(currentName);
            if (row &&
                !('splitFrom' in row) &&
                !('mergedFrom' in row) &&
                !processedIds.has(row.id)) {
                regularRows.push(row);
                processedIds.add(row.id);
            }
        }
    });
    // Second pass: collect split and merged columns
    metaColumns.forEach(function (column) {
        var columnActions = config[column] || [];
        var splitAction = columnActions.find(function (a) { return a.action === 'split'; });
        var mergeAction = columnActions.find(function (a) { return a.action === 'merge'; });
        if (splitAction === null || splitAction === void 0 ? void 0 : splitAction.final_names) {
            // Add split children in order
            splitAction.final_names.forEach(function (originalName) {
                var currentName = getCurrentName(originalName);
                var row = findRowById(currentName);
                if (row &&
                    'splitFrom' in row &&
                    row.splitFrom === column &&
                    !processedIds.has(row.id)) {
                    splitAndMergedRows.push(row);
                    processedIds.add(row.id);
                }
            });
        }
        else if (mergeAction === null || mergeAction === void 0 ? void 0 : mergeAction.final_name) {
            // Add merged row
            var row = findRowById(mergeAction.final_name);
            if (row && 'mergedFrom' in row && !processedIds.has(row.id)) {
                splitAndMergedRows.push(row);
                processedIds.add(row.id);
            }
        }
    });
    // Combine: regular rows first, then split/merged rows
    var orderedRows = __spreadArrays(regularRows, splitAndMergedRows);
    // Add any remaining rows (shouldn't happen, but just in case)
    Object.values(rowMap).forEach(function (row) {
        if (!processedIds.has(row.id)) {
            orderedRows.push(row);
        }
    });
    // Rebuild rowMap with correct order, using current id as key
    var orderedRowMap = {};
    orderedRows.forEach(function (row) {
        orderedRowMap[row.id] = row;
    });
    // Replace rowMap
    Object.keys(rowMap).forEach(function (key) { return delete rowMap[key]; });
    Object.assign(rowMap, orderedRowMap);
    var renderMetaName = function (row) {
        var badge = null;
        if ('splitFrom' in row) {
            badge = (react_1["default"].createElement(box_1["default"], { padding: "4px 8px", backgroundColor: "blue.pastel", borderRadius: "4px", ml: "6px" },
                react_1["default"].createElement(text_1["default"], { variant: "body.sm", color: "blue.haptik" }, "Split")));
        }
        if ('mergedFrom' in row) {
            badge = (react_1["default"].createElement(box_1["default"], { padding: "4px 8px", backgroundColor: "blue.pastel", borderRadius: "4px", ml: "6px" },
                react_1["default"].createElement(text_1["default"], { variant: "body.sm", color: "blue.haptik" }, "Merged")));
        }
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(text_1["default"], { variant: "body.md", style: { wordBreak: 'break-word' } }, row.metaName),
            badge));
    };
    // Helper to find the original split field name by tracing through renames
    var findOriginalSplitFieldName = function (row, mappings) {
        var _a;
        if (!row.originalSplitAction) {
            return row.id;
        }
        var splitAction = row.originalSplitAction;
        var currentName = row.algoliaName || row.id;
        // Check if current name is in the original split names
        if ((_a = splitAction.final_names) === null || _a === void 0 ? void 0 : _a.includes(currentName)) {
            return currentName;
        }
        // Trace through rename chain to find original name
        var originalNames = splitAction.final_names || [];
        var foundOriginal;
        originalNames.forEach(function (originalName) {
            if (foundOriginal)
                return; // Already found
            var name = originalName;
            var visited = new Set();
            // Follow rename chain
            while (mappings[name]) {
                if (visited.has(name))
                    break; // Prevent infinite loops
                visited.add(name);
                var renameAction = mappings[name].find(function (a) {
                    return a.action === 'rename';
                });
                if (renameAction) {
                    if (renameAction.final_name === currentName) {
                        foundOriginal = originalName;
                        return;
                    }
                    name = renameAction.final_name;
                }
                else {
                    break;
                }
            }
        });
        if (foundOriginal) {
            return foundOriginal;
        }
        // Fallback to current name if we can't trace back
        return currentName;
    };
    // Add actions for split/merge child fields instead of modifying the parent action
    var applyChangeForSplitOrMergeChild = function (row, action) {
        var _a;
        var mappingsJson = JSON.parse(JSON.stringify(rawAlgoliaMapping || {}));
        // Determine which field name to use for storing the action
        // For split children: use the original field name (handles renames)
        // For merged rows: use the row id (the merged field name)
        var fieldNameForAction;
        if ('splitFrom' in row && row.splitFrom) {
            fieldNameForAction = findOriginalSplitFieldName(row, mappingsJson.mappings || {});
        }
        else if ('mergedFrom' in row && row.mergedFrom) {
            // For merged rows: prefer existing mapping keys so repeated renames update
            // the same mapping instead of creating new ones.
            // Candidate name is the current algoliaName (what UI shows before change)
            var candidateName = row.algoliaName;
            // 1) If mapping already exists under candidateName, use it
            if (mappingsJson.mappings && mappingsJson.mappings[candidateName]) {
                fieldNameForAction = candidateName;
            }
            else {
                // 2) Try to find an existing mapping key whose actions include a rename
                // that targets candidateName or (when action is rename) the new final name.
                var targetNames_1 = new Set();
                targetNames_1.add(candidateName);
                if (action.action === 'rename') {
                    targetNames_1.add(action.final_name);
                }
                var foundKey_1;
                if (mappingsJson.mappings) {
                    Object.keys(mappingsJson.mappings).some(function (k) {
                        var acts = mappingsJson.mappings[k] || [];
                        var matches = acts.some(function (a) {
                            if (a.action === 'rename') {
                                return targetNames_1.has(a.final_name);
                            }
                            return false;
                        });
                        if (matches) {
                            foundKey_1 = k;
                            return true;
                        }
                        return false;
                    });
                }
                if (foundKey_1) {
                    fieldNameForAction = foundKey_1;
                }
                else if (mappingsJson.mappings && mappingsJson.mappings[row.id]) {
                    // 3) Fallback: if a mapping exists under the merged row's id, use it
                    fieldNameForAction = row.id;
                }
                else {
                    // 4) Default: use the candidateName (this will create a new mapping)
                    fieldNameForAction = candidateName;
                }
            }
        }
        else {
            return null;
        }
        // Get existing actions for the field (or create new array)
        var existingActions = ((_a = mappingsJson.mappings) === null || _a === void 0 ? void 0 : _a[fieldNameForAction]) || [];
        // For rename/type_cast/merge actions, update existing or add new
        if (action.action === 'rename' ||
            action.action === 'type_cast' ||
            action.action === 'merge') {
            var existingIndex = existingActions.findIndex(function (a) { return a.action === action.action; });
            if (existingIndex !== -1) {
                // Update existing action
                existingActions[existingIndex] = action;
            }
            else {
                // Add new action
                existingActions.push(action);
            }
            mappingsJson.mappings[fieldNameForAction] = existingActions;
        }
        else {
            // For other actions, just add them
            existingActions.push(action);
            mappingsJson.mappings[fieldNameForAction] = existingActions;
        }
        // Ensure mappings object exists
        if (!mappingsJson.mappings) {
            mappingsJson.mappings = {};
        }
        return mappingsJson;
    };
    var onChange = function (fieldName, action, isUpdate, row) {
        var _a, _b, _c, _d;
        var _e;
        if (isUpdate === void 0) { isUpdate = false; }
        // If editing a split or merge child row, add actions to the child field instead of modifying parent action
        if (row && ('splitFrom' in row || 'mergedFrom' in row)) {
            var updatedMappingsJson = applyChangeForSplitOrMergeChild(row, action);
            if (updatedMappingsJson) {
                onAdvancedSettingsChange(updatedMappingsJson);
                return;
            }
        }
        // Normal flow for non-split rows or if split update failed
        var mappingsJson = JSON.parse(JSON.stringify(rawAlgoliaMapping || {}));
        var existingActions = ((_e = mappingsJson.mappings) === null || _e === void 0 ? void 0 : _e[fieldName]) || [];
        if (isUpdate) {
            // Update: Replace the existing split action with the new one
            var updatedActions = existingActions.map(function (existingAction) {
                return existingAction.action === 'split' ? action : existingAction;
            });
            mappingsJson.mappings = __assign(__assign({}, mappingsJson.mappings), (_a = {}, _a[fieldName] = updatedActions, _a));
            // If updating a split action, clean up any existing rename/type_cast actions
            // for the split children since the split action now contains the updated values
            if (action.action === 'split') {
                // Get the old split action to find original child names
                var oldSplitAction = existingActions.find(function (a) { return a.action === 'split'; });
                if (oldSplitAction === null || oldSplitAction === void 0 ? void 0 : oldSplitAction.final_names) {
                    // Helper to find current name after renames
                    var getCurrentNameAfterRenames_1 = function (originalName) {
                        var _a;
                        var childActions = ((_a = mappingsJson.mappings) === null || _a === void 0 ? void 0 : _a[originalName]) || [];
                        var renameAction = childActions.find(function (a) { return a.action === 'rename'; });
                        return (renameAction === null || renameAction === void 0 ? void 0 : renameAction.final_name) || originalName;
                    };
                    // For each original split child name, find its current name and clean up actions
                    oldSplitAction.final_names.forEach(function (originalName) {
                        var _a, _b;
                        var currentName = getCurrentNameAfterRenames_1(originalName);
                        // Clean up actions for the current name (which might be renamed)
                        if ((_a = mappingsJson.mappings) === null || _a === void 0 ? void 0 : _a[currentName]) {
                            var filteredActions = mappingsJson.mappings[currentName].filter(function (a) {
                                return a.action !== 'rename' && a.action !== 'type_cast';
                            });
                            if (filteredActions.length === 0) {
                                delete mappingsJson.mappings[currentName];
                            }
                            else {
                                mappingsJson.mappings[currentName] = filteredActions;
                            }
                        }
                        // Also clean up actions for the original name (in case rename wasn't applied yet)
                        if (currentName !== originalName && ((_b = mappingsJson.mappings) === null || _b === void 0 ? void 0 : _b[originalName])) {
                            var filteredActions = mappingsJson.mappings[originalName].filter(function (a) {
                                return a.action !== 'rename' && a.action !== 'type_cast';
                            });
                            if (filteredActions.length === 0) {
                                delete mappingsJson.mappings[originalName];
                            }
                            else {
                                mappingsJson.mappings[originalName] = filteredActions;
                            }
                        }
                    });
                }
            }
            onAdvancedSettingsChange(mappingsJson);
            return;
        }
        // Create: Add new action
        // For rename/type_cast, update existing if present, otherwise add new
        if (action.action === 'rename' || action.action === 'type_cast') {
            var existingIndex = existingActions.findIndex(function (a) { return a.action === action.action; });
            if (existingIndex !== -1) {
                existingActions[existingIndex] = action;
                mappingsJson.mappings = __assign(__assign({}, mappingsJson.mappings), (_b = {}, _b[fieldName] = existingActions, _b));
            }
            else {
                mappingsJson.mappings = __assign(__assign({}, mappingsJson.mappings), (_c = {}, _c[fieldName] = __spreadArrays(existingActions, [action]), _c));
            }
        }
        else {
            mappingsJson.mappings = __assign(__assign({}, mappingsJson.mappings), (_d = {}, _d[fieldName] = __spreadArrays(existingActions, [action]), _d));
        }
        onAdvancedSettingsChange(mappingsJson);
    };
    // Convert map -> table rows
    var structuredRowData = Object.values(rowMap);
    // Helper to compute effective split action with current values from row data
    var getEffectiveSplitAction = function (row) {
        if (!('splitFrom' in row) || !row.originalSplitAction) {
            return undefined;
        }
        var splitFrom = row.splitFrom;
        // Find all rows that were split from the same parent
        var splitChildren = structuredRowData.filter(function (r) { return 'splitFrom' in r && r.splitFrom === splitFrom; });
        if (splitChildren.length === 0) {
            return row.originalSplitAction;
        }
        // Build effective split action with current names and types
        var effectiveAction = __assign(__assign({}, row.originalSplitAction), { final_names: splitChildren.map(function (r) { return r.algoliaName || r.id; }), final_types: splitChildren.reduce(function (acc, r) {
                var _a;
                var fieldName = r.algoliaName || r.id;
                return __assign(__assign({}, acc), (_a = {}, _a[fieldName] = r.dataType, _a));
            }, {}) });
        return effectiveAction;
    };
    // Helper to compute effective merge action with current values from row data
    var getEffectiveMergeAction = function (row) {
        if (!('mergedFrom' in row) || !row.originalMergeAction) {
            return undefined;
        }
        // Build effective merge action with current final_name and final_type
        var effectiveAction = __assign(__assign({}, row.originalMergeAction), { final_name: row.algoliaName, final_type: row.dataType });
        return effectiveAction;
    };
    var handleToggleActive = function (row, newActive) {
        var _a;
        var _b;
        // For split children, we need to find the original field name
        var fieldName = row.id;
        if ('splitFrom' in row) {
            var originalFieldName = findOriginalSplitFieldName(row, (rawAlgoliaMapping === null || rawAlgoliaMapping === void 0 ? void 0 : rawAlgoliaMapping.mappings) || {});
            fieldName = originalFieldName || row.id;
        }
        if (newActive) {
            // Remove drop action to activate the row
            var mappingsJson = JSON.parse(JSON.stringify(rawAlgoliaMapping || {}));
            var existingActions = ((_b = mappingsJson.mappings) === null || _b === void 0 ? void 0 : _b[fieldName]) || [];
            var updatedActions = existingActions.filter(function (a) { return a.action !== 'drop'; });
            if (updatedActions.length === 0) {
                delete mappingsJson.mappings[fieldName];
            }
            else {
                mappingsJson.mappings = __assign(__assign({}, mappingsJson.mappings), (_a = {}, _a[fieldName] = updatedActions, _a));
            }
            onAdvancedSettingsChange(mappingsJson);
        }
        else {
            // Add drop action to deactivate the row
            onChange(fieldName, { action: 'drop' }, false, row);
        }
    };
    var handleDrop = function (row) {
        // For split children, we need to find the original field name
        var fieldName = row.id;
        if ('splitFrom' in row) {
            var originalFieldName = findOriginalSplitFieldName(row, (rawAlgoliaMapping === null || rawAlgoliaMapping === void 0 ? void 0 : rawAlgoliaMapping.mappings) || {});
            fieldName = originalFieldName || row.id;
        }
        onChange(fieldName, { action: 'drop' }, false, row);
    };
    var rowData = structuredRowData.map(function (row, index) {
        var isDisabled = !row.active;
        var disabledStyle = isDisabled ? { opacity: 0.5 } : {};
        var fieldName = row.metaName;
        if ('splitFrom' in row || 'mergedFrom' in row) {
            fieldName = row.id;
        }
        return {
            id: index + 1,
            columns: [
                generateColumn(react_1["default"].createElement(checkbox_1["default"].Item, { value: row.active, onChange: function (checked) { return handleToggleActive(row, checked); } })),
                generateColumn(react_1["default"].createElement(box_1["default"], { style: disabledStyle, alignItems: "center" }, renderMetaName(row))),
                generateColumn(react_1["default"].createElement(text_2["default"], { themed: true, placeholder: "Enter the Algolia name", value: row.algoliaName, style: __assign({ height: '32px' }, disabledStyle), onChange: function (val) {
                        if (!isDisabled) {
                            onChange(fieldName, {
                                action: 'rename',
                                final_name: val,
                            }, false, row);
                        }
                    }, disabled: isDisabled })),
                generateColumn(react_1["default"].createElement(dropdown_1["default"], { themed: true, options: FIELD_TYPE_OPTIONS, optionKey: "name", value: FIELD_TYPE_OPTIONS.find(function (opt) { return opt.name === row.dataType; }) ||
                        FIELD_TYPE_OPTIONS[0], onChange: function (option) {
                        if ((option === null || option === void 0 ? void 0 : option.name) && !isDisabled) {
                            onChange(fieldName, {
                                action: 'type_cast',
                                final_type: option.name,
                            }, false, row);
                        }
                    }, placeholder: "Select field type", inputStyles: { height: '32px', marginTop: '-6px' }, optionsStyle: { zIndex: 1000000010 }, disabled: isDisabled })),
                generateColumn(react_1["default"].createElement(box_1["default"], { padding: "0", style: disabledStyle },
                    'splitFrom' in row && (react_1["default"].createElement(ThemedSplitButton, { themed: true, onClick: function () {
                            if (!isDisabled) {
                                // Compute effective split action with current values
                                var effectiveAction = getEffectiveSplitAction(row);
                                var rowWithEffectiveAction = effectiveAction
                                    ? __assign(__assign({}, row), { originalSplitAction: effectiveAction }) : row;
                                setSplitModalData(rowWithEffectiveAction);
                                setSplitModalActive(true);
                            }
                        }, disabled: isDisabled },
                        react_1["default"].createElement(ThemedJourneyIcon, { themed: true, size: "small", iconColor: "blue.haptik" }),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "blue.haptik" }, "Edit"))),
                    'mergedFrom' in row && (react_1["default"].createElement(ThemedSplitButton, { themed: true, onClick: function () {
                            if (!isDisabled) {
                                // Compute effective merge action with current values
                                var effectiveAction = getEffectiveMergeAction(row);
                                var rowWithEffectiveAction = effectiveAction
                                    ? __assign(__assign({}, row), { originalMergeAction: effectiveAction }) : row;
                                setMergeModalData(rowWithEffectiveAction);
                                setMergeModalActive(true);
                            }
                        }, disabled: isDisabled },
                        react_1["default"].createElement(ThemedJourneyIcon, { themed: true, size: "small", iconColor: "blue.haptik" }),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "blue.haptik" }, "Edit"))),
                    !('splitFrom' in row) && !('mergedFrom' in row) && (react_1["default"].createElement(ThemedSplitButton, { themed: true, onClick: function () {
                            if (!isDisabled) {
                                setSplitModalData(row);
                                setSplitModalActive(true);
                            }
                        }, disabled: isDisabled },
                        react_1["default"].createElement(ThemedJourneyIcon, { themed: true, size: "small", iconColor: "blue.haptik" }),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "blue.haptik" }, "Split"))),
                    react_1["default"].createElement(ThemedDropButton, { themed: true, onClick: function () {
                            if (!isDisabled) {
                                handleDrop(row);
                            }
                        }, disabled: isDisabled },
                        react_1["default"].createElement(ThemedBinIcon, { themed: true, size: "small", iconColor: "red.haptik" }),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "red.haptik" }, "Drop")))),
            ],
        };
    });
    var onUndoSplit = function (fieldName) {
        var _a;
        var _b;
        var mappingsJson = JSON.parse(JSON.stringify(rawAlgoliaMapping || {}));
        var existingActions = ((_b = mappingsJson.mappings) === null || _b === void 0 ? void 0 : _b[fieldName]) || [];
        // Remove the split action from the array
        var updatedActions = existingActions.filter(function (existingAction) { return existingAction.action !== 'split'; });
        mappingsJson.mappings = __assign(__assign({}, mappingsJson.mappings), (_a = {}, _a[fieldName] = updatedActions, _a));
        // If no actions remain for this field, remove the field entry
        if (updatedActions.length === 0) {
            delete mappingsJson.mappings[fieldName];
        }
        onAdvancedSettingsChange(mappingsJson);
    };
    var onUndoMerge = function (fieldName) {
        var _a;
        var _b;
        var mappingsJson = JSON.parse(JSON.stringify(rawAlgoliaMapping || {}));
        var existingActions = ((_b = mappingsJson.mappings) === null || _b === void 0 ? void 0 : _b[fieldName]) || [];
        // Remove the merge action from the array
        var updatedActions = existingActions.filter(function (existingAction) { return existingAction.action !== 'merge'; });
        mappingsJson.mappings = __assign(__assign({}, mappingsJson.mappings), (_a = {}, _a[fieldName] = updatedActions, _a));
        // If no actions remain for this field, remove the field entry
        if (updatedActions.length === 0) {
            delete mappingsJson.mappings[fieldName];
        }
        onAdvancedSettingsChange(mappingsJson);
    };
    return (react_1["default"].createElement(ModalV2_1["default"], { title: "Meta Catalog Sync Advanced settings", subtitle: "", headerIcon: null, headerSubIcon: null, active: active, classPrefix: "metaAlgoliaMapping", isV2: true, toggleModal: closeModal },
        react_1["default"].createElement(box_1["default"], { padding: "0", margin: "12px 12px 0 0", justifyContent: "flex-end" },
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "primary", onClick: function () {
                    setMergeModalActive(true);
                } }, "Merge Fields")),
        react_1["default"].createElement(table_1["default"], { simple: true, sortable: true, columns: columns, rows: rowData, prefixClassName: "metaAlgoliaMappingTable" }),
        react_1["default"].createElement(SplitModal_1["default"], { active: splitModalActive, closeModal: function () {
                setSplitModalActive(false);
                setSplitModalData(null);
            }, data: splitModalData, setData: setSplitModalData, onChange: onChange, onUndo: onUndoSplit, originalSplitAction: splitModalData && 'originalSplitAction' in splitModalData
                ? splitModalData.originalSplitAction
                : undefined }),
        react_1["default"].createElement(MergeModal_1["default"], { active: mergeModalActive, closeModal: function () {
                setMergeModalActive(false);
                setMergeModalData(null);
            }, data: mergeModalData, setData: setMergeModalData, onChange: onChange, 
            // Provide a filtered list to MergeModal that excludes dropped columns.
            // - When editing (mergeModalData present): pass original `metaColumns`
            //   but exclude any that have a `drop` action in the mappings.
            // - When creating a new merge: pass the current visible table rows
            //   (only active ones) so users can merge currently available fields.
            metaColumns: mergeModalData
                ? metaColumns.filter(function (col) {
                    var acts = config[col] || [];
                    return !acts.some(function (a) { return a.action === 'drop'; });
                })
                : structuredRowData
                    .filter(function (r) {
                    if (!r.active)
                        return false;
                    if ('splitFrom' in r)
                        return false;
                    if ('mergedFrom' in r)
                        return false;
                    return true;
                })
                    .map(function (row) { return row.metaName; }), onUndo: onUndoMerge })));
};
exports["default"] = MetaAlgoliaMapping;
MetaAlgoliaMapping.propTypes = {
    active: prop_types_1["default"].bool,
    closeModal: prop_types_1["default"].func.isRequired,
    actionData: prop_types_1["default"].shape((_a = {},
        _a[ACTION_DETAILS_KEY] = prop_types_1["default"].objectOf(prop_types_1["default"].shape((_b = {},
            _b[META_COLUMNS_KEY] = prop_types_1["default"].arrayOf(prop_types_1["default"].string),
            _b[ALGOLIA_MAPPING_KEY] = prop_types_1["default"].shape({
                mappings: prop_types_1["default"].objectOf(prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
                    action: prop_types_1["default"].string.isRequired,
                }))),
            }),
            _b))),
        _a)).isRequired,
};
MetaAlgoliaMapping.defaultProps = {
    active: false,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
